import React from "react";
import { NavLink } from "react-router-dom";
// link lagana hai yahan
function PostItem(props) {
  return (
    <NavLink to={props?.link}>
      <div
        className="single-post-item "
        style={{
          width: "500px",
          gap: "20",
        }}
      >
        <NavLink to={props?.link}>
          <img
            src={props?.productImgSrc}
            alt=""
            style={{
              width: "500px",
              height: "400px",
            }}
          />
        </NavLink>

        {/* Post Content */}
        <div className="post-content">
          <NavLink to={props?.link} className="category">
            {props?.category}
          </NavLink>
          <h5 className="post-title">{props?.title}</h5>
          <p>{props?.description}</p>

          <ul className="meta">
            <li>
              <NavLink to={props?.link}>Author : {props.authorName.substring(0, 5) + "...." + props?.authorName?.slice(-4)}</NavLink>
            </li>
            <li>
              <NavLink to={props?.link}>{props?.date}</NavLink>
            </li>
          </ul>
        </div>
        {/* End Post Content */}
      </div>
    </NavLink>
  );
}

export default PostItem;
